import { Chip, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { Star, StarBorder } from "@mui/icons-material";
import MDBox from "../../controls/MDBox";

// Puntaje del Disparador de un caso y marca de prioritario (plan 3.2c). Todo usuario ve el número y la estrella; solo los perfiles
// que pueden administrar el Disparador (puedeMarcar) pueden tocar la estrella para marcar o quitar la marca de prioritario: para
// el resto es un indicador sin acción. Un caso cerrado muestra el puntaje que tenga guardado pero no lleva estrella: ya no se
// trabaja, no se puede marcar como prioritario.
function PuntajeCaso({ puntaje, puedeMarcar = false, cerrado = false, ocupado, onTogglePrioritario }) {
  const prioritario = !!puntaje?.prioritario;

  return (
    <MDBox display="flex" alignItems="center" gap={0.5} mb={0.5} ml={4} onClick={(e) => e.stopPropagation()}>
      <Chip
        size="small"
        color={prioritario ? "warning" : "default"}
        label={puntaje ? `Puntaje: ${puntaje.puntaje}` : "Sin puntaje"}
        sx={{ fontWeight: "bold" }}
      />
      {!cerrado &&
        (puedeMarcar ? (
          <Tooltip title={prioritario ? "Quitar la marca de prioritario" : "Marcar como prioritario"} arrow>
            <span>
              <IconButton size="small" disabled={ocupado} onClick={() => onTogglePrioritario(!prioritario)}>
                {ocupado ? <CircularProgress size={16} /> : prioritario ? <Star color="warning" fontSize="small" /> : <StarBorder fontSize="small" />}
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          // Mismo tamaño que el botón (relleno de 5 px), para que el puntaje quede alineado igual para todos.
          <MDBox component="span" display="inline-flex" p="5px">
            {prioritario ? (
              <Star color="warning" fontSize="small" titleAccess="Caso prioritario" />
            ) : (
              <StarBorder fontSize="small" sx={{ color: "action.disabled" }} titleAccess="Caso no prioritario" />
            )}
          </MDBox>
        ))}
    </MDBox>
  );
}

export default PuntajeCaso;
